import React from "react";
import {
    Card,
    Select,
    Typography,
    Space,
    Divider,
    Switch,
    Layout,
    Row,
    Col,
} from "antd";
import {
    EnvironmentOutlined,
    ApartmentOutlined,
    TeamOutlined,
} from "@ant-design/icons";

const { Title, Text } = Typography;
const { Option } = Select;

const CompareCompensation = () => {

    return (
        <Layout style={{ padding: "24px" }}>
            <Title level={4}>Compensation Summary</Title>
            <Row gutter={[16, 16]}>
                <Col span={8}>
                    <Card>
                        <Title level={5} style={{ marginBottom: "8px" }}>
                            <TeamOutlined style={{ marginRight: "8px", color: "#1890ff" }} />
                            Business Units
                        </Title>
                        <Text>
                            Use this to compare compensation costs between Business Units.
                            Maximum three BUs are allowed for comparison.
                        </Text>
                    </Card>
                </Col>
                <Col span={8}>
                    <Card>
                        <Title level={5} style={{ marginBottom: "8px" }}>
                            <EnvironmentOutlined
                                style={{ marginRight: "8px", color: "#52c41a" }}
                            />
                            Locations
                        </Title>
                        <Text>
                            Use this to compare compensation costs between Locations.
                            Maximum three Locations are allowed for comparison.
                        </Text>
                    </Card>
                </Col>
                <Col span={8}>
                    <Card>
                        <Title level={5} style={{ marginBottom: "8px" }}>
                            <ApartmentOutlined
                                style={{ marginRight: "8px", color: "#fa8c16" }}
                            />
                            Departments
                        </Title>
                        <Text>
                            Use this to compare compensation costs between Departments.
                            Maximum three Departments are allowed for comparison.
                        </Text>
                    </Card>
                </Col>
            </Row>
        </Layout>
    );
}

export default CompareCompensation;